// Ported from the legacy TransferConfirmationScreen.js: when the session has no fixed
// authorizationAmount, show this range instead of guessing a single number.
export const MIN_AUTHORIZATION_AMOUNT_NGN = 50
export const MAX_AUTHORIZATION_AMOUNT_NGN = 100

// Spec §7
export const OTP_LENGTH = 6
export const OTP_RESEND_COOLDOWN_SECS = 90
export const OTP_MAX_ATTEMPTS = 3
